/**
 * Normalize FastAPI / axios error responses to a renderable string.
 *
 * FastAPI returns validation errors as { detail: [{type, loc, msg, input, ctx, url}, ...] }
 * which crashes React when rendered directly ("Objects are not valid as a React child").
 * This helper safely converts every shape we encounter into plain text.
 */
export function formatApiError(err, fallback = 'Kļūda. Mēģini vēlreiz.') {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (typeof d === 'string') return d;
        const loc = Array.isArray(d?.loc) ? d.loc.filter((x) => x !== 'body').join('.') : '';
        return loc ? `${loc}: ${d.msg || ''}`.trim() : (d?.msg || JSON.stringify(d));
      })
      .filter(Boolean)
      .join('; ');
  }
  if (typeof detail === 'object') return detail.msg || JSON.stringify(detail);
  return String(detail);
}
